import { supabase } from '../lib/supabase';

export const VOICE_PROVIDERS = ['vapi', 'retell'];
const KEY = 'voice_provider';

/** Never throws. Unknown/missing/error → 'vapi'. */
export const getVoiceProvider = async () => {
  try {
    const { data, error } = await supabase
      .from('app_settings')
      .select('value')
      .eq('key', KEY)
      .maybeSingle();
    if (error) {
      console.warn('[settings] voice_provider read failed, defaulting to vapi:', error.message);
      return 'vapi';
    }
    return VOICE_PROVIDERS.includes(data?.value) ? data.value : 'vapi';
  } catch (err) {
    console.warn('[settings] voice_provider read threw, defaulting to vapi:', err);
    return 'vapi';
  }
};

/** Never throws. Error or a thrown query → null (the admin UI renders "unknown"). */
export const getVoiceProviderSetting = async () => {
  try {
    const { data, error } = await supabase
      .from('app_settings')
      .select('value, updated_at, updated_by')
      .eq('key', KEY)
      .maybeSingle();
    if (error) return null;
    return data;
  } catch (err) {
    console.warn('[settings] voice_provider setting read threw:', err);
    return null;
  }
};

export const setVoiceProvider = async (provider, userId) => {
  if (!VOICE_PROVIDERS.includes(provider)) {
    return { error: `Invalid provider: ${provider}` };
  }
  const { error } = await supabase
    .from('app_settings')
    .upsert(
      { key: KEY, value: provider, updated_at: new Date().toISOString(), updated_by: userId ?? null },
      { onConflict: 'key' },
    );
  return { error: error ? error.message : null };
};

export default { getVoiceProvider, getVoiceProviderSetting, setVoiceProvider, VOICE_PROVIDERS };
